import React from 'react';
import {Chip, IconButton, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography,} from '@mui/material';
import {Delete as DeleteIcon, Edit as EditIcon} from '@mui/icons-material';

const MemberTable = ({members, onEdit, onDelete, onView, canEdit, canDelete}) => {
    const calculateAge = (dateOfBirth) => {
        if (!dateOfBirth) return '-';
        const today = new Date();
        const birthDate = new Date(dateOfBirth);
        let age = today.getFullYear() - birthDate.getFullYear();
        const monthDiff = today.getMonth() - birthDate.getMonth();
        if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birthDate.getDate())) {
            age--;
        }
        return age;
    };

    const formatDate = (dateString) => {
        if (!dateString) return '-';
        return new Date(dateString).toLocaleDateString('de-DE');
    };

    const getGenderLabel = (gender) => {
        switch (gender) {
            case 'MALE':
                return 'Männlich';
            case 'FEMALE':
                return 'Weiblich';
            case 'DIVERS':
                return 'Divers';
            case 'UNKNOWN':
                return 'Unbekannt';
            default:
                return '-';
        }
    };

    return (
        <TableContainer component={Paper}>
            <Table>
                <TableHead>
                    <TableRow>
                        <TableCell><strong>Name</strong></TableCell>
                        <TableCell><strong>Geburtsdatum</strong></TableCell>
                        <TableCell><strong>Alter</strong></TableCell>
                        <TableCell><strong>Geschlecht</strong></TableCell>
                        <TableCell><strong>Mitglieds-Nr.</strong></TableCell>
                        <TableCell><strong>Einheit</strong></TableCell>
                        <TableCell><strong>Seit</strong></TableCell>
                        <TableCell><strong>Status</strong></TableCell>
                        {canEdit || canDelete ? (
                            <TableCell align="right"><strong>Aktionen</strong></TableCell>) : null
                        }
                    </TableRow>
                </TableHead>
                <TableBody>
                    {members.length === 0 ? (
                        <TableRow>
                            <TableCell colSpan={9} align="center">
                                <Typography variant="body2" color="textSecondary" sx={{py: 4}}>
                                    Noch keine Mitglieder vorhanden. Erstellen Sie das erste Mitglied!
                                </Typography>
                            </TableCell>
                        </TableRow>
                    ) : (
                        members.map((member) => (
                            <TableRow
                                key={member.id}
                                hover
                                onClick={() => onView(member)}
                                sx={{cursor: 'pointer'}}
                            >
                                <TableCell>
                                    <Typography variant="body1" fontWeight="600">
                                        {member.firstName} {member.lastName}
                                    </Typography>
                                </TableCell>
                                <TableCell>
                                    <Typography variant="body2">
                                        {formatDate(member.dateOfBirth)}
                                    </Typography>
                                </TableCell>
                                <TableCell>
                                    <Typography variant="body2">
                                        {calculateAge(member.dateOfBirth)} Jahre
                                    </Typography>
                                </TableCell>
                                <TableCell>
                                    <Typography variant="body2">
                                        {getGenderLabel(member.gender)}
                                    </Typography>
                                </TableCell>
                                <TableCell>
                                    <Typography variant="body2">
                                        {member.memberCardId || '-'}
                                    </Typography>
                                </TableCell>
                                <TableCell>
                                    <Typography variant="body2">
                                        {member.unit?.name || '-'}
                                    </Typography>
                                </TableCell>
                                <TableCell>
                                    <Typography variant="body2">
                                        {formatDate(member.activeSince)}
                                    </Typography>
                                </TableCell>
                                <TableCell>
                                    <Chip
                                        label={member.activeUntil ? 'Inaktiv' : 'Aktiv'}
                                        color={member.activeUntil ? 'default' : 'success'}
                                        size="small"
                                    />
                                </TableCell>
                                { (canEdit || canDelete) && (
                                <TableCell align="right">
                                    {canEdit && (
                                        <IconButton
                                            color="primary"
                                            onClick={(e) => {
                                                e.stopPropagation();
                                                onEdit(member);
                                            }}
                                            size="small"
                                            title="Bearbeiten"
                                        >
                                            <EditIcon/>
                                        </IconButton>
                                    )}
                                    {canDelete && (
                                        <IconButton
                                            color="error"
                                            onClick={(e) => {
                                                e.stopPropagation();
                                                onDelete(member);
                                            }}
                                            size="small"
                                            title="Löschen"
                                        >
                                            <DeleteIcon/>
                                        </IconButton>
                                    )}
                                </TableCell>
                                )}
                            </TableRow>
                        ))
                    )}
                </TableBody>
            </Table>
        </TableContainer>
    );
};

export default MemberTable;

